import React from 'react';
import styled from 'styled-components';
import Grid from '@mui/material/Grid';
import { PageNotFound } from '@buoyhealth/common.buoy-page-not-found';
import { SecondaryCTAButton } from '@buoyhealth/common.buoy-button';

const emptyArray = [] as any;

const StyledGrid = styled(Grid)`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;

  button {
    background-color: white;
  }

  > div > div:first-of-type {
    height: 129px;
    display: flex;
    justify-content: center;
  }

  div {
    font-size: 24px;
    margin: 24px 0 16px;

    &:last-child,
    &:first-child {
      font-size: 18px;
      margin: 0;
    }
  }
`;

const ErrorContainer = ({
  triggerRestart,
  buttonText,
  className,
  ...rest
}: {
  triggerRestart: () => void;
  headline?: string;
  subHeader?: string;
  buttonText?: string;
  className?: string;
}) => (
  <StyledGrid item className={className}>
    <PageNotFound
      bodyText=""
      headline="Something went wrong."
      links={emptyArray}
      subHeader="We're sorry about that. Please try again."
      {...rest}
    />
    <SecondaryCTAButton onClick={triggerRestart} sx={{ margin: '32px 0 16px' }}>
      {buttonText || 'Restart'}
    </SecondaryCTAButton>
  </StyledGrid>
);

export default ErrorContainer;
